import React from 'react';
import PropTypes from 'prop-types';
import ExternalPromotionToast from 'bento-ordering/promotions/components/ExternalPromotionToast';

function CateringExternalPromotionToast({ isSuccess, error }) {
  if (!isSuccess && error === null) {
    return null;
  }

  const getToastMessage = () => {
    if (error?.code === 404) {
      return 'Sorry, promotion has expired';
    } else if (error?.code === 409) {
      return 'Promotion available!';
    } else if (isSuccess) {
      return 'Promotion unlocked!';
    }
  };

  return <ExternalPromotionToast toastMessage={getToastMessage()} />;
}

CateringExternalPromotionToast.propTypes = {
  isSuccess: PropTypes.bool,
  error: PropTypes.shape({
    code: PropTypes.number
  })
};

export default CateringExternalPromotionToast;
